import React, { forwardRef, useImperativeHandle, useState } from 'react'

const CountTimeComponent = forwardRef((props, ref) => {
  const [audioLength, setAudioLength] = useState<string>()
  const updateValue = (newValue: string) => {
    setAudioLength(newValue)
  }

  // Expose the `updateValue` method to parent components
  useImperativeHandle(ref, () => ({ updateValue }))
  return (
    <>
      {!!audioLength && (
        <span>
          <span className="text-secondary">Odhad editoru: </span>
          {audioLength}
        </span>
      )}
    </>
  )
})

CountTimeComponent.displayName = 'CountTimeComponent'

export default CountTimeComponent
